import { memo, useCallback, useEffect } from 'react';
import ListItem from '@mui/material/ListItem';
import { useParams, useNavigate } from 'react-router-dom';
// Local files
import { ItemTitle, StyledListItemButton } from './Item.styled';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useClinicians from 'hooks/useClinicians';
import useCustomSelector from 'hooks/useCustomSelector';
import { cliniciansSelectors } from 'features/clinicians';

const Item = ({ id, first_name, last_name }) => {
  const { clinician_id } = useParams();
  const navigate = useNavigate();
  const { getClinician } = useClinicians();
  const fetching = useCustomSelector(cliniciansSelectors.clinicianIsFetching)

  const handleSelectClinician = (e) => { 
    e.stopPropagation();
    id !== clinician_id && navigate(`/providers/${id}`) 
  };
  const fetchClinician = useCallback((clinician_id) => {
    getClinician(clinician_id)
  }, [getClinician]);

  useEffect(() => {
    !!clinician_id && id === clinician_id && fetchClinician(clinician_id);
  }, [id, clinician_id, fetchClinician]);

  return (
    <ListItem disablePadding>
      <StyledListItemButton selected={id === clinician_id} disabled={fetching} onClick={handleSelectClinician}>
        <ItemTitle>{`${first_name} ${last_name}`}</ItemTitle>
      </StyledListItemButton>
    </ListItem>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Item {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);